<template>
  <div class="dashboard">
    <router-view></router-view>
    <!-- <Index/> -->
  </div>
</template>

<script>
 /* eslint-disable */
 import Index from '@/components/attributes/Index.vue';

export default {
  name: "attributes",
  components:{
    Index
  }
};
</script>
